import { useTranslation } from "react-i18next";
import { Button, DismissibleTag } from "@carbon/react";
import { ScreenContext } from "../../types";
import { useScreenTitle } from "../../hooks/useScreenAssistant";

type Props = {
  context: ScreenContext;
  /** Whether the next question goes with this screen. */
  active: boolean;
  onToggle: (active: boolean) => void;
};

/**
 * Says which screen the next question is about — "Pedido: Rodamientos" — and lets the user
 * leave it out. The title is display only; the backend reads the record again for the model.
 */
const ScreenContextChip = ({ context, active, onToggle }: Props) => {
  const { t } = useTranslation();
  const { data } = useScreenTitle(context, active);
  const kind = t(`screenAssistant.kinds.${context.kind}`);
  const label = data?.title ? `${kind}: ${data.title}` : kind;

  if (!active) {
    return (
      <div className="screen-assistant__context">
        <Button kind="ghost" size="sm" onClick={() => onToggle(true)}>
          {t("screenAssistant.context.use", { screen: kind })}
        </Button>
      </div>
    );
  }

  return (
    <div className="screen-assistant__context">
      <span className="screen-assistant__context-label">
        {t("screenAssistant.context.about")}
      </span>
      <DismissibleTag
        type="blue"
        size="sm"
        text={label}
        title={t("screenAssistant.context.remove")}
        onClose={() => onToggle(false)}
      />
    </div>
  );
};

export default ScreenContextChip;
